export default __webpack_public_path__ + "static/media/aduio_line.9fe590e9.png";